import './Commentçamarche.css';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Calendar, Truck, FileCheck } from 'lucide-react';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';

const shapeStyles = { bgcolor: 'red', width: 120, height: 120 };
const shapeCircleStyles = { borderRadius: '50%' };
const circle = (
	<Box component='span' sx={{ ...shapeStyles, ...shapeCircleStyles }}>
		<Phone color='white' size={100} />
	</Box>
);

const circle1 = (
	<Box component='span' sx={{ ...shapeStyles, ...shapeCircleStyles }}>
		<Calendar color='white' size={100} />
	</Box>
);

const circle2 = (
	<Box component='span' sx={{ ...shapeStyles, ...shapeCircleStyles }}>
		<Truck color='white' size={100} />
	</Box>
);
const circle3 = (
	<Box component='span' sx={{ ...shapeStyles, ...shapeCircleStyles }}>
		<FileCheck color='white' size={100} />
	</Box>
);

const Commentçamarche = () => {
	return (
		<div className='home'>
			<Header></Header>
			<br />
			<center>
				<h2>
					<span class='badge rounded-pill text-danger text-bg-danger bg-opacity-50'>Notre Processus</span>
				</h2>
				<br />
				<h1>Comment ça marche ?</h1>
				<br />
				<p>Un processus simple et rapide en 4 étapes</p>
				<br />
				<div class='container text-center'>
					<div class='row'>
						<div class='col'>
							<h1>
								<Badge color='success' overlap='circular' badgeContent='01'>
									{circle}
								</Badge>
							</h1>
							<h3>Contactez-nous</h3>Appelez-nous ou remplissez le formulaire en ligne avec les informations sur votre véhicule.
						</div>
						<div class='col'>
							<h1>
								<Badge color='success' overlap='circular' badgeContent='02'>
									{circle1}
								</Badge>
							</h1>
							<h3>Rendez-vous</h3>Nous fixons ensemble un rendez-vous sous 24 à 48h selon vos disponibilités.
						</div>
						<div class='col'>
							<h1>
								<Badge color='success' overlap='circular' badgeContent='03'>
									{circle2}
								</Badge>
							</h1>
							<h3>Enlèvement</h3>Notre équipe intervient rapidement où que vous soyez dans le Pays Basque, les Landes ou le Béarn.
						</div>
						<div class='col'>
							<h1>
								<Badge color='success' overlap='circular' badgeContent='04'>
									{circle3}
								</Badge>
							</h1>
							<h3>Certificat</h3>Vous recevez immédiatement votre certificat de destruction officiel.
						</div>
					</div>
				</div>
				<br />
				<div class='row  mx-auto  p-5'>
					<div class='card  text-center bg-gradient' style={{ backgroundColor: '#003300' }}>
						<div class='card-body text-white'>
							<br />
							<h3 class='card-title'>📍 Intervention dans 2 départements</h3>
							<p class='card-text'>Nous couvrons le Pays Basque, le Béarn et les Landes (64 et 40)</p>
							<br />
							<div class='row'>
								<div class='col-sm-6 mb-4 mb-sm-4'>
									<div class='card text-bg-light bg-opacity-25 text-start'>
										<div class='card-body  '>
											<h5 class='card-title text-danger'>
												<b>Pyrénées-Atlantiques (64)</b>
											</h5>
											<p class='card-text p-3 text-white'>
												<li>Bayonne • Biarritz • Pau</li>
												<li>Anglet • Hendaye</li>
												<li>Oloron • Orthez</li>
											</p>
										</div>
									</div>
								</div>
								<div class='col-sm-6'>
									<div class='card text-bg-light bg-opacity-25 text-start'>
										<div class='card-body'>
											<h5 class='card-title text-danger'>
												<b>Landes (40)</b>
											</h5>
											<p class='card-text p-3 text-white'>
												<li>Dax • Mont-de-Marsan</li>
												<li>Biscarrosse • Capbreton</li>
												<li>Mimizan • Tarnos</li>
											</p>
										</div>
									</div>
								</div>
							</div>
							<br />
							<p>+ toutes les communes environnantes de ces départements</p>
						</div>
					</div>
				</div>
			</center>
			<br />
			<Footer></Footer>
		</div>
	);
};

export default Commentçamarche;
